module.exports = __webpack_public_path__ + "img/loader-1.d340c3a1.gif";